<template>
    <div class="modal-goodslist" :style="goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">老人档案</div>
                <el-button type="success" style="float:left" @click="closeSelf">关闭</el-button>
            </div>
            <div class="modal-body" :style="bodyStyle">
                <template>
                    <el-tabs v-model="activeName"  type="card" :before-leave='beforeLeave'>
                        <el-tab-pane label="老人基本信息" :style="tabPaneStyle">
                            <BasicInfo v-if="!disOrInitList[0]" :ref="tabNameList[0]"></BasicInfo>
                        </el-tab-pane>
                        <el-tab-pane label="亲属信息" :style="tabPaneStyle">
                            <RelativesInfo v-if="!disOrInitList[1]" :ref="tabNameList[1]"></RelativesInfo>
                        </el-tab-pane>
                        <el-tab-pane label="挂钩帮扶信息" :style="tabPaneStyle">
                            <HookInfo v-if="!disOrInitList[2]"  :ref="tabNameList[2]"></HookInfo>
                        </el-tab-pane>
                        <el-tab-pane label="基本健康信息" :style="tabPaneStyle">
                            <HealthInfo v-if="!disOrInitList[3]"  :ref="tabNameList[3]"></HealthInfo>
                        </el-tab-pane>
                        <el-tab-pane label="健康履历" :style="tabPaneStyle">
                            <HealthRecord v-if="!disOrInitList[4]"  :ref="tabNameList[4]"></HealthRecord>
                        </el-tab-pane>
                        <el-tab-pane label="特长爱好" :style="tabPaneStyle">
                            <SpecialHobby v-if="!disOrInitList[5]"  :ref="tabNameList[5]"></SpecialHobby>
                        </el-tab-pane>
                        <el-tab-pane label="用药记录" :style="tabPaneStyle">
                            <MedicalRecords v-if="!disOrInitList[6]"  :ref="tabNameList[6]"></MedicalRecords>
                        </el-tab-pane>
                        <el-tab-pane label="体检记录" :style="tabPaneStyle">
                            <ExaminationRecords v-if="!disOrInitList[7]"  :ref="tabNameList[7]"></ExaminationRecords>
                        </el-tab-pane>
                        <el-tab-pane label="就诊记录" :style="tabPaneStyle">
                            <SeeDoctorRecords v-if="!disOrInitList[8]"  :ref="tabNameList[8]"></SeeDoctorRecords>
                        </el-tab-pane>
                    </el-tabs>
                </template>
            </div>
            <!-- <div class="modal-footer">
                <el-button type="success" @click="closeSelf">关闭</el-button>
            </div> -->
        </div>
    </div>

</template>

<script>
    import BasicInfo from './BasicInfo'
    import ExaminationRecords from './ExaminationRecords'
    import RelativesInfo from './RelativesInfo'
    import HookInfo from './HookInfo'
    import HealthInfo from './HealthInfo'
    import HealthRecord from './HealthRecord'
    import SpecialHobby from './SpecialHobby'
    import MedicalRecords from './MedicalRecords'
    import SeeDoctorRecords from './SeeDoctorRecords'
    // import ElImageViewer from 'element-ui/packages/image/src/image-viewer';

    export default {
        name: 'Edit',
        data() {
            return {
                activeName:"0",
                elData:'',
                loading: false,
                disOrInitList:[true,true,true,true,true,true,true,true,true],
                tabNameList:['myBasicInfo',
                'myRelativesInfo',
                'myHookInfo',
                'myHealthInfo',
                'myHealthRecord',
                'mySpecialHobby',
                'myMedicalRecords',
                'myExaminationRecords',
                'mySeeDoctorRecords'],
                dialogIdCardValue: '',
                bodyStyle: "height:" + (this.$store.state.tableHeight + 150) + 'px',
                tabPaneStyle:{
                    height: (this.$store.state.tableHeight+55) + 'px',
                    "overflow-y": "auto"
                },
                goodslist: '',
            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight': function (val) {
                this.bodyStyle = "height:" + (val + 150) + 'px';
                this.tabPaneStyle.height = (val + 55) + 'px';
            },
        },
        components: {
            BasicInfo,
            ExaminationRecords,
            RelativesInfo,
            HookInfo,
            HealthInfo,
            HealthRecord,
            SpecialHobby,
            MedicalRecords,
            SeeDoctorRecords,
        },
        methods: {
            init(row) {
                this.elData=row
                this.activeName="0"
                this.disOrInitList=[false,true,true,true,true,true,true,true,true]
                this.$nextTick(() => {
                    this.$refs[this.tabNameList[parseInt(0)]].init(true,this.elData,true)
                })
                var appNav = document.getElementsByClassName('app-nav');
                this.goodslist = "left:" + appNav[0].scrollWidth + 'px'
            },
            closeSelf() {
                this.$nextTick(() => {
                    this.$refs[this.tabNameList[0]].$parent.$el.scrollTop=0
                })
                this.$emit("closeInfo");
            },
            beforeLeave(activeName){
                if(this.disOrInitList[parseInt(activeName)]){
                    this.disOrInitList[parseInt(activeName)]=false
                    this.$nextTick(() => {
                        //var disable=true
                        this.$refs[this.tabNameList[parseInt(activeName)]].init(true,this.elData,true)
                        this.$refs[this.tabNameList[parseInt(activeName)]].$parent.$el.scrollTop=0
                    })
                }
            }
        }








    }


</script>


<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0, 0, 0, .3);
        display: flex;
        // justify-content: center;
        // align-items: center;
        z-index: 99;
        /deep/ .el-checkbox__input.is-disabled.is-checked+span.el-checkbox__label {
            color: #409EFF;
            cursor: not-allowed;
        }

        /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
            background-color: #409EFF;
            border-color: #409EFF;
        }
        /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
            border-color: #fff;
        }
        .modal {
            background-color: #fff;
            box-shadow: none;
            border-radius: 0;
            // overflow-x:auto;
            // display: flex;
            // flex-direction: column;
            // border-radius: 10px;
            width: 100%;

            .modal-header {
                border: 0;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 0px 0px 20px;
                z-index: 99;
                overflow-y: auto;
                height: 500px;
                /deep/ .el-tabs--card>.el-tabs__header {
                    margin: 0;
                }
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;

                .el-button {
                    width: 15%;
                }
            }
            .uploadButton {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 10px 0 0;
                display: flex;

                .el-button {
                    width: 35%;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left: 16px;
        width: 56px;
        height: 36px;
        border: none;
        cursor: pointer;
    }

    .btn-close {
        color: #313131;
        background-color: transparent;
    }


    .row {
        padding: 10px 0px;
    }

    .item {
        padding: 0px 20px;
    }

    .label {
        padding: 5px 0px;
    }


</style>
